import {CARGAR_CLIENTE, INICIALIZAR_CLIENTE} from './actionTypes';
import { INICIALIZAR_FORM } from '../generales/actionTypes';
import { completar_String } from '../../funciones_globales/format';
import { get_FechaLocalActual } from '../../funciones_globales/utils';
import { formatearFecha } from '../../funciones_globales/format';
import global_axios from '../../funciones_globales/interaccionapi';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';

export const cargar_Cliente = (cliente) => {
	return (dispatch) => {
		
		let config_request = {
			method: 'GET',
			url: '/clientes/' + cliente,
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)			
		.then((response)=> {
			let cliente = response.data;
			
			cliente.fecha_nacimiento = formatearFecha(cliente.fecha_nacimiento);
			cliente.ContbEspecial = cliente.ContbEspecial!==null?cliente.ContbEspecial:'N';	

			cliente.Cprospecto = cliente.Cprospecto!==null?cliente.Cprospecto:'N';	
			cliente.NaturalezaSeguro = cliente.NaturalezaSeguro!==null?cliente.NaturalezaSeguro:'I';	
			
			
			cliente.TipoIdentificacion = cliente.TipoIdentificacion?cliente.TipoIdentificacion.toString().trim():null;
			/* VALIDACION DE Parroquia */
			let parroquia = cliente.parroquia?cliente.parroquia:null;
			let arrayContructor = {}.constructor;

			if(parroquia !== null){
				if(parroquia.constructor !== arrayContructor){
					cliente.parroquia = null;
				}
			}
			dispatch({
				type: CARGAR_CLIENTE,
				data: cliente
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar cliente', mensaje: msgError}
			});
		});
	}
}

export const inicializarCliente = () => {
	return {
		type: INICIALIZAR_CLIENTE,
		data: null
	};
}

export const setClienteSeleccionado = (clienteSeleccionado) => {
	return {
		type: CARGAR_CLIENTE,
		data: clienteSeleccionado
	};
}

export const cargar_ValoresIniciales = () => {
	return (dispatch) => {
		
		let config_request = {
			method: 'GET',
			url: '/secuenciales/Cliente',
		}
		
		return global_axios(config_request)			
		.then( response => {						
			let cod_secuencial = completar_String(response.data.codigo, '0', 7);			
			let fecha = get_FechaLocalActual();
			
			dispatch({
				type: INICIALIZAR_FORM,
				data: {	codigo: cod_secuencial,						
						fecha_nacimiento: fecha,
						tipo_persona: 'N',
						sexo: 'M',
						status_cli: 'A',
						tipo_cliente: 'P',
						origen_ingresos: 'I',
						forma_pago: 'CR',
						tipo_credito: 'C',
						parte_relacionada: 'NO',
						Retiene: 'S',
						legal: 'N',
						ContbEspecial: 'N',
						flete: 'N',
						TipoIdentificacion: 'C',
						status_tipocli:'N',
						Cprospecto:'N',
						NaturalezaSeguro:'I'
					}			
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;			
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar valores iniciales de cliente', mensaje: msgError}
			});
		});
	}
}